import Layout from '@/layout'

const route = {
  path: '/merChant',
  component: Layout,
  redirect: '/merChant/index',
  alwaysShow: true, // will always show the root menu
  name: 'merChant',
  meta: {
    title: '商户',
    icon: 'diy-UhHu',
    roles: [
      'capital'
    ]
  },
  children: [
    {
      path: '/merchantlist/index',
      component: () => import('@/views/merchantList/index.vue'),
      name: 'Merchantlist',
      meta: {
        title: '商户号列表',
        // icon: 'component'
        roles: [
          'capital.merchant.list'
        ]
      }
    },
    {
      path: '/officialAccountMerchant/index',
      component: () => import('@/views/officialAccountMerchant/index.vue'),
      name: 'OfficialAccountMerchant',
      meta: {
        title: '公众号绑定商户',
        // icon: 'component'
        roles: [
          'capital.merchantBindOa.list'
        ]
      }
    },
    {
      path: '/redPacketRecord/index',
      component: () => import('@/views/redPacketRecord/index.vue'),
      name: 'RedPacketRecord',
      meta: {
        title: '红包记录',
        // icon: 'component'
        roles: [
          'capital.redPacket.list'
        ]
      }
    }
    // {
    //   path: '/merchantMaintenanceNumber',
    //   component: Layout,
    //   // redirect: '/customer/publicPlan/index',
    //   alwaysShow: true, // will always show the root menu
    //   name: 'merchantMaintenanceNumber',
    //   meta: {
    //     title: '商户养号',
    //     icon: 'el-icon-s-cooperation',
    //     roles: [
    //       'merchant.maintenance.number'
    //     ]
    //   },
    //   children: [
    //     {
    //       path: '/denterpriselinks/denterpriselinksing/index',
    //       component: () => import('@/views/denterpriselinksing/index.vue'),
    //       name: 'BackConfig',
    //       meta: {
    //         title: '企业微信',
    //         icon: 'component',
    //         roles: [
    //           'wechat_company.index'
    //         ]
    //       }
    //     },
    //     {
    //       path: '/merchantpay/merchantpaying/index',
    //       component: () => import('@/views/merchantpaying/index.vue'),
    //       name: 'BackConfig',
    //       meta: {
    //         title: '商户号支付',
    //         icon: 'component',
    //         roles: [
    //           'pay_code.index'
    //         ]
    //       }
    //     }
    //   ]
    // }
  ]
}

export default route
